module.exports = __webpack_public_path__ + "static/media/c1.a2894df5.jpg";